import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { confirmOrder } from '../../../State/Admin/Orders/Action';

const OrderClose = () => {
    const navigate = useNavigate();
    const {auth}=useSelector(store=>store);
    const {cart}=useSelector(store=>store);
    const dispatch=useDispatch();
    const location=useLocation();
    const querySearch=new URLSearchParams(location.search);
    const orderId=querySearch.get("order_id");

    useEffect(()=>{
      if(cart?.status==='Success'){
        const reqData={
          orderId:orderId,
          reqJWT:auth?.jwt?.access_token
        }
        dispatch(confirmOrder(reqData)).then(()=>{
          alert('Enquiry Confirmmed');
        });
      }
    },[cart?.status]);

  return (  
    <div>
      <section class="h-screen">
        <div class="px-6 h-full text-gray-800">
          <div class="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full g-6">
            <div class="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                class="w-full"
                alt="Sample image"
              />
            </div>
            <div class="xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 mb-12 md:mb-0">
              <form>
                <div class="flex flex-row items-center justify-center lg:justify-start">
                  <h1 class="text-2xl font-bold mb-0 mr-4">
                        Your enquiry is submited to seller. You will be received WhatsApp msg for your enquiry and seller of product contacted with you recently.
                  </h1>
                </div>
                <div>
                  <h1>
                    If your not received WhatsApp messages plz back to Product Page here.
                    {/*<Button onClick={()=>(navigate('/cart'))}>
                        Back here
                    </Button>*/}
                  </h1>
                </div>
                <div class="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5">
                  <h2>Welcome HOME </h2>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default OrderClose
